module.exports = __webpack_public_path__ + "static/media/mortgage_icon.a27833b7.svg";